import { API } from 'utils/api.config';

export async function getContentByRecommendation({ payload }) {
  return await API.get(`api/recommend`);
}
export async function getAllRecommendationApi(type) {
  return await API.get(`api/content/recommendation/seemore`, {
    params: type
  });
}
